<template>
      <div class="publicViewClass" style="padding-top:0">
         <div class="edit-step">
            <topicSteps :active = "2" :propList="propList"></topicSteps>
        </div>
        <div id="editPaper" class="app-inner">
               <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            上一步
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="openThree"
            >
             下一步
           </el-button>
            </div>
            <div class="edit-from">
                    <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  配置考核评分规则
            </div>
        </div>
        <div class="edit-from-list">
            <div class="edit-from-list-check flex align-cen">
                <div class="label isRequild">选择工况：</div>
                <el-select v-model="omId" placeholder="选择工况" clearable @change="getOmNmae">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" 
                        >
                        </el-option>
                    </el-select>
            </div>
            <div class="edit-from-list-op flex align-cen">
                <div class="btn-set addgc" @click="addProcess('')">
                    添加过程
                </div>
                <div class="btn-right flex mft">
                <div class="btn-set" @click="openSteps">
                    导入过程步骤
                </div>
                 <el-button class="btn-set" @click="uploadFm" :loading='uploadLoading'>
                    下载仪表阀门表
                </el-button>
                 <div class="btn-set addgc"  @click="addStep('')">
                    添加步骤
                </div>
                </div>
            </div> 
            <div class="el-tabs__content-e">
             <div class="f-h-flex2">
                <div class="categories-tree">
                    <div class="categories-tree-tab">
                      <div class="categories-tree-tab-tit flex align-cen">
                        <div class="categories-tree-tab-tit-1 categories-tree-tab-tit-p" style="width:20%">序号</div>
                        <div class="categories-tree-tab-tit-2 categories-tree-tab-tit-p" style="width:30%">过程名称</div>
                        <div class="categories-tree-tab-tit-3 categories-tree-tab-tit-p" style="width:50%">操作</div>
                        </div>  
                        <div class="categories-tree-tab-item flex align-cen" v-for="(item,index) in itemList" :key="item.id"
                        :class="{'Proactive':isActive == index}"
                        @click="switchpro(item,index)"
                        >
                            <div class="categories-tree-tab-item-con" style="width:20%">
                                {{item.sort || '-'}}
                            </div>
                                 <el-tooltip class="item" effect="dark" :content="item.processName" placement="top">
                             <div class="categories-tree-tab-item-con publictitline2" style="width:30%">
                                {{item.processName}}
                            </div>
                               </el-tooltip>
                             <div class="categories-tree-tab-item-con" style="width:50%">
                                <div class="categories-tree-tab-item-con-b flex align-cen">
                                    <div class="btnred"
                                    @click.stop="addData(item,index,'up')"
                                    >向上添加</div>
                                     <div class="btnred"
                                      @click.stop="addData(item,index,'down')"
                                     >向下添加</div>
                                </div>
                                 <div class="categories-tree-tab-item-con-b flex align-cen">
                                    <div class="btnred" @click.stop="addProcess(item.id)">编辑</div>
                                     <div class="btnred" @click.stop="deletProcess(item)">删除</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="categories-panel-dragger"></div>
                <div class="questions-panel grow">
                     <el-table
                    :data="itemList1"
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333',height:'40px'}"
                    >
                        <el-table-column label="" align="center"   width="80">
                     <template slot-scope="scope" >
                                <div class="handle_move">
                                <i  class="icon-al-arrows-alt"  style="font-size:22px"/>
                            </div>
                       </template>
                   </el-table-column>
                              <el-table-column prop="sort" label="序号" align="center" width="80">
                        </el-table-column>
                        <el-table-column prop="stepName" label="步骤名称" align="center" width="150">
                        </el-table-column>
                         <el-table-column prop="stepStartDesc" label="前提条件" align="center" width="200">
                        </el-table-column>
                         <el-table-column prop="stepTargetDesc" label="目标条件" align="center" width="200">
                        </el-table-column>
                          <el-table-column prop="stepTerminalDesc" label="结束条件" align="center" width="200">
                        </el-table-column>
                          <el-table-column prop="score" label="分值" align="center" width="100">
                        </el-table-column>
                         <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="250"
                        >
                         <template slot-scope="scope">
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addData1(scope.row,scope.$index,'up')">向上添加</el-button>
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addData1(scope.row,scope.$index,'down')">向下添加</el-button>
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addStep(scope.row.id)">编辑</el-button>
                                     <el-button type="text" size="small"  slot="reference" style="color:red" @click="deletStep(scope.row)">删除</el-button>
                                </template>
                         </el-table-column>
                    </el-table>
                </div>
            </div>
            </div>
        </div>
            </div>
        </div>
         <!-- 打开过程编辑 -->
                 <el-dialog
                    :title="processTit"
                    :visible.sync="centerDialogVisible"
                    width="40%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible"
                    >
                         <div class="forminfo"> 
                            <rasoProcess  
                            :propId="propId"
                            :propAppId="list.appId"
                            :propSort="propSort"
                             @emitFun="handleData"
                            ref="rasoProcessTemplate"
                            ></rasoProcess>
                            <div class="authbtn flex align-cen">
                                    <el-button plain  @click="centerDialogVisible = false">取消</el-button>
                                    <el-button type="primary" class="" @click="onSubmit">确认</el-button>
                                </div>
                        </div>
                 </el-dialog>
            <!-- 打开步骤编辑 -->
                <el-dialog
                    :title="stepTit"
                    :visible.sync="centerDialogVisible1"
                    width="40%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible1"
                    >
                         <div class="forminfo"> 
                            <rasoSteps  
                            :propId="propId1"
                            :propSort="propSort1"
                            :propAppId="list.appId"
                             @emitFun="handleData1"
                            ref="rasoStepTemplate"
                            ></rasoSteps>
                            <div class="authbtn flex align-cen">
                                    <el-button plain  @click="centerDialogVisible1 = false">取消</el-button>
                                    <el-button type="primary" class="" @click="onSubmit1">确认</el-button>
                                </div>
                        </div>
                </el-dialog>
      </div> 
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import rasoProcess from "@/components/rasoProcess1.vue"; //过程组件
import rasoSteps from "@/components/rasoStep2.vue"; //步骤组件
import Sortable from "sortablejs";
import axios from "axios";
import {editEmuPaper,EmuPaperDetail,omList,processList,getProcess,editProcess,stepList,editStep,getStep} from "@/api/enterprise/index"   //工况检测、新增试卷、查询仿真试卷详情、工况列表、过程列表、获取、删除过程、新增过程、步骤列表
export default {
    name:'twoIndex',
     components: {
        topicSteps,
        rasoProcess,
        rasoSteps
    },
    data() {
        return {
        uploadLoading:false,
        headers:{},
        businessInfo:{},
        isActive:0,
        oldIndex: null,
        newIndex: null,
        stepId:'',
        propId:'',
        propSort:'',
        propId1:'',
        propSort1:'',
        processTit:'新增过程',
        stepTit:'新增步骤',
        centerDialogVisible:false,
        centerDialogVisible1:false,
        omId:'',
        loading:false,
        options:[],
        itemList:[],
        itemList1:[],
        propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'配置步骤',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

        ],
        list:{},
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getPaperDetail()  
        this.getprocessList()
         let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 上一步
        reback(){
             this.$router.push({
            name:'addEnRaso',
            query:{
                id:this.$route.query.twoId
            }
            })
        },
        // 下一步
        openThree(){
            if(!this.omId) return  this.$util.Notifi('请选择工况','error','fa-exclamation-circle');
            if(!this.itemList.length) return this.$util.Notifi('请添加过程','error','fa-exclamation-circle');
            this.loading = true;
               editEmuPaper({...this.list,id:this.$route.query.twoId,businessId:this.businessInfo.id},'put')
                        .then(res => {
                             this.loading = false
                           if(res.code == 0){    
                                setTimeout(() => {
                           this.$router.push({
                            name:'endEnRaso',
                            query:{
                                threeId:this.$route.query.twoId
                            }
                           })
                             }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
        // 过程切换
        switchpro(data,index){
            this.isActive = index
            this.getprocessList(data.id)
        },
        handleData(){
            this.getprocessList(this.stepId)
            this.centerDialogVisible = false
        },
         handleData1(){
            this.getStepList(this.stepId)
            this.centerDialogVisible1 = false
         },
         onSubmit(){
              this.$refs.rasoProcessTemplate.emitData()  
        },  
        onSubmit1(){
              this.$refs.rasoStepTemplate.emitData1()  
        },  
           // 向上向下添加数据
        addData(item,index,type){
            // 数据、索引、向上还是向下
            let sort;
            if(type == 'up'){
               sort = item.sort || index + 1
            }else{
                sort = item.sort + 1
            }
             this.propSort = sort
            this.centerDialogVisible = true
        // let params = {
        //     paperId:this.$route.query.twoId,
        //     processName:item.processName,
        //     startCondition:item.startCondition,
        //     endCondition:item.endCondition,
        //     sort:sort,
        // }
        // let method = "post"
        //       editProcess(params,method)
        //     .then(res => {
        //         if(res.code == 0){
        //         this.getprocessList(this.stepId)
        //         }else{
        //         this.$message.error(res.msg)
        //         }
        //     })
        //     .catch(err => {
        //     })
        },
        // 向上向下添加步骤
        addData1(item,index,type){
          let sort;
            if(type == 'up'){
               sort = item.sort || index + 1
            }else{
                sort = item.sort + 1
            }
              this.propId1 = item.id
            this.propSort1 = sort
            this.centerDialogVisible1= true
            // delete this.itemList1[index].id;  
            // this.commentsFun(this.itemList1[index],'post')
        },
        commentsFun(params,method){
        editStep(params,method)
        .then(res => {
        if(res.code == 0){
            this.getStepList(this.stepId)
        }else{
            this.$message.error(res.msg)
        }
        })
        .catch(err => {
        })
        },
        // 添加过程
        addProcess(id){
            this.propSort = ''
            if(id){
                this.propId = id
                this.processTit='编辑过程'
            }else{
                 this.propId = ''
                this.processTit='新增过程'
            }
            this.centerDialogVisible = true
        },
        // 添加步骤
        addStep(id){
            this.propSort1 = ''
             if(id){
                this.propId1= id
                this.stepTit='编辑步骤'
            }else{
                 this.propId1 = ''
                this.stepTit='新增步骤'
            }
            this.centerDialogVisible1 = true
        },
        // 获取过程列表
        getprocessList(stepId){
            processList({paperId:this.$route.query.twoId})
            .then(res =>{
                this.itemList = res.data
                this.stepId = stepId ? stepId : this.itemList.length ? this.itemList[0].id : ''
                this.getStepList(this.stepId)
            })
        },
        // 获取步骤列表
        getStepList(processId){
            this.stepId = processId
            stepList({paperId:this.$route.query.twoId,processId:processId})
            .then(res =>{
               this.itemList1 = res.data || []
               this.$nextTick(() =>{
                 this.init()
            })
            })
        },
        // 删除步骤
        deletStep(data){
          console.log(this.$refs['rasoStepTemplate'])
            let that= this
                this.$confirm('确定要删除该步骤？删除后试卷将不再具备该考核步骤【不会影响之前的考试结果】', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.getStepDetai(data.id,'DELETE')
                })
        },
           // 获取步骤详情
        getStepDetai(id,method){
            getStep({id:id},method)
            .then(res =>{
                if(method == 'DELETE'){
                     this.$util.Notifi('删除成功','success','fa-check')
                     this.getStepList(this.stepId)
                }
            })
            },
        // 删除过程列表
        deletProcess(data){
              this.$confirm('确定要删除该过程？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
                }).then(() => {
                this.getProcessDetail(data.id,'DELETE')
                })
        },
        getProcessDetail(id,method){
            getProcess({id:id},method)
            .then(res =>{
                if(method == 'DELETE'){
                     this.$util.Notifi('删除成功','success','fa-check')
                     this.isActive = 0
                     this.getprocessList()
                }
            })
        },
        // 打开导入过程步骤
        openSteps(){
              this.$router.push({
                name:'enImportStep',
                query:{
                    id:this.$route.query.twoId || this.list.id,
                    appId:this.list.appId
                }
                })
        },
        // 选择工况获取工况文件路径
        getOmNmae(){
            let filteredItems = this.options.filter(item => item.id == this.omId); 
            this.list.omId = filteredItems[0].id;
            this.list.omFile = filteredItems[0].file
        },
        // 获取防真试卷详情
          getPaperDetail(){
            EmuPaperDetail({id:this.$route.query.twoId},'get')
            .then(res =>{
              this.list = res.data
              this.omId = res.data.omId
               this.getomList()  
            //   this.checkList = res.data.questionSet.split(',') || []
            })
            .catch(err =>{})
        },
        // 下载阀门列表
        uploadFm(){
         this.uploadLoading = true
             axios
       .get(`${this.$config.baseUrl}/assess/emuPaper/instrumentExport?appId=${this.list.appId}&search=`, {
        headers:this.headers,
         responseType: "blob",
       })
         .then(response =>{
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `仪门阀表.xlsx`);
                document.body.appendChild(link);
                link.click();
                this.uploadLoading = false
                document.body.removeChild(link); 
         })
         .catch(err =>{this.uploadLoading = false})
        },
        // 获取工况列表
        getomList(){
            omList({appId:this.list.appId,id:'',name:''})
            .then(res =>{
                console.log(res)
               this.options = res.data
            })
        },
        getCheckReopenFun(){
            getCheckReopen({id:this.$route.query.twoId})
            .then(res =>{
                console.log(res)
            })
        },
                    	init(){
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.querySelector(".el-table__body-wrapper tbody");
		let _this = this;	
		// 2. 创建并配置相关参数
		var sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class
			draggable:'.el-table__row', // 允许拖拽的项目类名
            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
			// 拖拽中 回调函数
			 onMove(customEvent) {
	          // 禁止在拖拽过程中交换位置
	          // 可将初始位置及目标位置进行记录
	          _this.oldIndex = customEvent.dragged.rowIndex; //  初始位置
	          _this.newIndex = customEvent.related.rowIndex; // 目标位置
	          return false;  // 不进行交换
	          // 返回值有三个
	          // return false; — for cancel
	          // return -1; — insert before target
	          // return 1; — insert after target
	        },
			
			// 拖拽结束，调整位置
			onEnd() {
               
	          // 在拖拽结束后，获取初始及目标位置
	          const { newIndex, oldIndex } = _this;
	          const currRow = _this.itemList1.splice(oldIndex, 1)[0];
	          _this.itemList1.splice(newIndex, 0, currRow);
            for (let i in _this.itemList1) {
                _this.itemList1[i].sort = Number(i)+1
            }
            _this.commentsFun(_this.itemList1[newIndex],'put')
	          // 拖拽完成，初始位置及目标位置重置
	          _this.newIndex = null;
	          _this.oldIndex = null;
	        },
		})
	},
    }

}
</script>
<style lang="scss" scoped>
.handle_move {
  cursor: move;
}
.publicViewClass{
    margin-bottom: 60px;
}
.edit-from-list{
    padding: 20px 0;
    .label{
        font-weight: bold;
    }
    .isRequild{
        position: relative;
    }
    .isRequild::before{
        content: '*';
        color: #f56c6c;
        position: absolute;
        left: -10px;
    }
    .edit-from-list-op {
        margin: 20px 0;
    }
        .btn-set{
        width: 140px;
        margin-right: 16px;
        cursor: pointer;
        color: #409eff;
        border: 1px solid #409eff;
        padding: 7px 0px;
        border-radius: 4px!important;
        text-align: center;
        font-weight: 400 !important;
      }
      .addgc{
          border: none;
        background: #409eff;
        color: #fff;
        width: 208px;
      }
      .el-tabs__content-e{
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      }
      .f-h-flex2{
        display: flex;
        height: 700px;
        .categories-tree{
            height: inherit;
            width: 258px;
            overflow-y: auto;
            .categories-tree-tab{
                width: 100%;
                .categories-tree-tab-tit{
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    background: #f7f8fa;
                    font-size: #333;
                    .categories-tree-tab-tit-p{
                        text-align: center;
                    } 
                }
                .categories-tree-tab-item{
                    height: 60px;
                    cursor: pointer;
                     border-bottom: 1px solid #DCDFE6;
                    .categories-tree-tab-item-con{
                        text-align: center;
                        .categories-tree-tab-item-con-b{
                            height: 30px;
                            line-height: 30px;
                            .btnred{
                                color: red;
                                font-size: 12px;
                                width: 50%;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .Proactive{
                 border: 1px solid #409eff;
                }
            }
        }
        .categories-panel-dragger{
            position: relative;
            flex-shrink: 0;
            width: 16px;
            height: 100% !important;
            border-right: 1px solid #e6e6e6;
            background-color: #f2f2f2 !important;
        }
        .questions-panel{
            width: calc(100% - 274px);
            height: 100%;
            padding: 0px 0 0 0;
            position: relative;
            flex-grow: 1;
        }
      }
}
::v-deep{
      .authbtn{
        justify-content: center !important;
    }
      .el-dialog{
        margin-top: 5vh !important;
    }
       .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
        .el-table{
            .el-table__cell{
                padding: 0px 0 !important;
            }
            .has-gutter{
            .el-table__cell{
                padding: 1px 0 !important;
            }
            }
        }
}
</style>